export default __webpack_public_path__ + "static/media/vivabonito6.a3786ce5.jpg";